export const SUCCESS_MSGS = {
  BUY_GOODS_SUCCESS_MSG: "BUY_GOODS_SUCCESS_MSG",
  SEND_MONEY_SUCCESS_MSG: "SEND_MONEY_SUCCESS_MSG",
  WITHDRAW_CASH_SUCCESS_MSG: "WITHDRAW_CASH_SUCCESS_MSG",
  BUY_BUNDLE_SUCCESS_MSG: "BUY_BUNDLE_SUCCESS_MSG",
  OTHER_RECHARGE_SUCCESSS_MSG: "OTHER_RECHARGE_SUCCESSS_MSG",
  SELF_RECHARGE_SUCCESS_MSG: "SELF_RECHARGE_SUCCESS_MSG",
  BUY_AIRTIME_FOR_OTHERS_SUCCESS_MSG: "BUY_AIRTIME_FOR_OTHERS_SUCCESS_MSG",
  BUY_AIRTIME_FOR_SELF_SUCCESS_MSG: "BUY_AIRTIME_FOR_SELF_SUCCESS_MSG"
}